var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListingCentricStructure(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m235.978 395.426h63.876c4.409 0 7.984 3.697 7.984 8.104v28.242l-71.86.477z",
    fill: "#f2b633",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m421.164 395.426h63.759c4.409 0 8.1 3.697 8.1 8.104v28.242l-71.858.477v-36.823z",
    fill: "#f2b633",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m50.912 395.426h63.755c4.408 0 8.104 3.697 8.104 8.104v28.242l-71.858.477v-36.823z",
    fill: "#f2b633",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m217.03 39.83h124.293c8.58 0 15.731 7.033 15.731 15.73v55.174l-140.024.834z",
    fill: "#f2b633",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m433.083 372.902v-55.174h-168.979v55.174h-16.09v-55.174h-168.98v55.174h-16.207v-63.275c0-4.408 3.58-8.104 8.104-8.104h177.083v-77.342h16.09v77.342h177.079c4.409 0 8.104 3.695 8.104 8.104v63.275z",
    fill: "#495586"
  }), /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m207.021 391.734h26.099l20.495 20.496h51.361c4.409 0 8.105 3.691 8.105 8.1v51.006c0 4.531-3.696 8.104-8.105 8.104h-97.955c-4.408 0-7.983-3.572-7.983-8.104v-71.5c0-4.529 3.575-8.102 7.983-8.102z",
    fill: "#ffd23b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m392.205 391.734h25.979l20.499 20.496h51.479c4.409 0 7.989 3.691 7.989 8.1v51.006c0 4.531-3.58 8.104-7.989 8.104h-97.956c-4.409 0-8.1-3.572-8.1-8.104v-71.5c-.001-4.529 3.69-8.102 8.099-8.102z",
    fill: "#ffd23b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.952 391.734h25.979l20.499 20.496h51.478c4.409 0 7.985 3.691 7.985 8.1v51.006c0 4.531-3.576 8.104-7.985 8.104h-97.956c-4.409 0-8.103-3.572-8.103-8.104v-71.5c.001-4.529 3.694-8.102 8.103-8.102z",
    fill: "#ffd23b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160.667 32.561h50.646l40.039 40.039h100.104c8.58 0 15.727 7.152 15.727 15.732v99.504c0 8.58-7.146 15.613-15.727 15.613h-190.789c-8.703 0-15.731-7.033-15.731-15.613v-139.543c0-8.58 7.028-15.732 15.731-15.732z",
    fill: "#ffd23b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 327.021c9.533 0 17.398-7.861 17.398-17.395 0-9.535-7.865-17.279-17.398-17.279-9.534 0-17.28 7.744-17.28 17.279 0 9.534 7.746 17.395 17.28 17.395z",
    fill: "#69a7ff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListingCentricStructure);
export default __webpack_public_path__ + "static/media/listing-centric-structure.017ba7f76bbfd96c508695faa6620f16.svg";
export { ForwardRef as ReactComponent };